import React from 'react';
import Work from '@component/gridgio/project/work';

const WorkPage: React.FC = () => <Work />;

export default WorkPage;
